/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@file
Point d'entrée de la page d'accueil Association NEDAO

@author Fabio Bonfiglio <fabio.bonfiglio@protonmail.ch>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://association.nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.
	
	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

/* eslint-disable no-console */
console.clear();
let timingLbl = "Temps de chargement de l'application";
console.time(timingLbl);

import React from "react";
import ReactDOM from "react-dom";
import "./styles/main.scss";
import App from "./containers/App.jsx";

console.log(
	"%c                                                 \n" +
	"    ███╗   ██╗███████╗██████╗  █████╗  ██████╗     \n" +
	"    ████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗    \n" +
	"    ██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║    \n" +
	"    ██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║    \n" +
	"    ██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝    \n" +
	"    ╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝     ",
	"background: #FF5752; color: white; text-shadow: 2px 2px 4px #FFFFFF80;"
);
console.info(
	"%c~~~~ ©2020 Association NEDAO < info@nedao.ch > ~~~~",
	"background: #FF5752; color: white;"
);

ReactDOM.render(
	(
		<App/>
	), 
	document.getElementById("root")
);

console.timeEnd(timingLbl);
